export enum StatusOnGoingEnum {
  COMPLETED = 'COMPLETED',
  PENDING_PAYMENT = 'PENDING',
  PENDING_SIGNATURE_FILE = 'PENDING_SIGNATURE_FILE',
  PENDING_UPLOAD_FILE = 'PENDING_UPLOAD_FILE',
  CANCELED = 'CANCELED'
}

export type DataResponse = {
  id: string;
  companies_document_id: number;
  created_at: string;
  payment_url: string | null;
  status: string;
  statusEnum: StatusOnGoingEnum;
  title: string;
  value: number;
};
